import { Compass, Repeat, Square, BatteryCharging, Flame, Brain } from "lucide-react";

export const DIM_STYLE = {
  direzione: { c: "#E5A15A", icon: Compass },
  continuita: { c: "#5EEAD4", icon: Repeat },
  spazio: { c: "#93C5FD", icon: Square },
  ricarica: { c: "#C4B5FD", icon: BatteryCharging },
  motivazione: { c: "#FB7185", icon: Flame },
  mentalita: { c: "#F0ABFC", icon: Brain },
};

export const LVL_STYLE = {
  ripartire: { c: "#FCA5A5" },
  stabilizzare: { c: "#FCD34D" },
  potenziare: { c: "#86EFAC" },
};

function chip(color) {
  return { backgroundColor: `${color}22`, color, borderColor: `${color}55` };
}

export function DimensionBadge({ dimension, title, className = "" }) {
  const s = DIM_STYLE[dimension] || DIM_STYLE.direzione;
  const Icon = s.icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[12px] font-semibold uppercase tracking-wider ${className}`}
      style={chip(s.c)}
      data-testid={`dimension-badge-${dimension}`}
    >
      <Icon size={12} strokeWidth={2.4} />
      {title}
    </span>
  );
}

export function LevelBadge({ level, title, className = "" }) {
  const s = LVL_STYLE[level] || LVL_STYLE.ripartire;
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-[12px] font-semibold uppercase tracking-wider ${className}`}
      style={chip(s.c)}
      data-testid={`level-badge-${level}`}
    >
      {title}
    </span>
  );
}
